export default __webpack_public_path__ + "static/project-slide-2-768-700-7e670da30f2e1511ba59337d7a3e789e.webp";